export default __webpack_public_path__ + "static/media/sixtypercent.f52a48ff.gif";